import React, { useState, useEffect, useContext } from "react";
import { Map, Marker, GoogleApiWrapper, Polyline } from "google-maps-react";
import { HOST_URL } from "../../../../../Config";
import { getUserData, localStoragekey } from "../../../../Common/Utility/Utils";
import axios from "axios";
import { StoreContext } from "../../../../../Store/Provider";
import { CircularProgress } from "@material-ui/core";
import Backdrop from "@mui/material/Backdrop";
import { NotificationManager } from "react-notifications";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ContainerDetails from "./ContainerDetails";
import FlightData from "./FlightData";
import { useNavigate, useLocation } from "react-router-dom";
import { routeConstant } from "../../../../../Route/utils/routeConstant";

function MilestoneMapComponent(props) {
  const [open, setOpen] = React.useState(false);
  const [showmapPointsData, setShowmapPointsData] = useState(false);
  const [locType, setLocType] = useState("");
  const [locName, setLocName] = useState("");
  const location = useLocation();

  const pathOptions = {
    strokeOpacity: 1,
    strokeColor: `rgba(0, 185, 181)`,
    strokeWeight: 2,
    icons: [
      {
        icon: {
          path: props.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          strokeOpacity: 0,
          fillColor: "#0000FF",
          fillOpacity: 1.0,
          scale: 2.5,
        },
        repeat: "80px",
      },
    ],
  };

  return (
    <div className="_orderListFullDetailsMap">
      <div className="mapComponent">
        <Map
          google={props.google}
          center={location.state.center}
          zoom={2}
          bounds={location.state.bounds}
        >
          {location.state.mapData.data.map((ele) => {
            return (
              <Marker
                icon={{
                  url: `${HOST_URL}${ele.markerIconUrl}`,
                  scaledSize: new window.google.maps.Size(25, 25),
                }}
                title={`${ele.locType}: ${ele.locName}`}
                position={{ lat: ele.lat, lng: ele.lng }}
              />
            );
          })}
          <Polyline path={location.state.polygon} options={pathOptions} />
        </Map>
        {showmapPointsData && (
          <div className="mapPointsData">{`${locType}: ${locName}`}</div>
        )}
        {location.state.mapData.loading ? (
          <div
            className="loadingContent"
            style={{
              height: "100%",
              position: "relative",
            }}
          >
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
                position: "absolute",
              }}
              open={true}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        ) : null}
      </div>
      {location.state.state.TransportMode === "SEA" ? (
        <ContainerDetails />
      ) : location.state.state.TransportMode === "AIR" ? (
        <FlightData data={location.state.state} />
      ) : null}
    </div>
  );
}
export default GoogleApiWrapper({
  apiKey: "AIzaSyDpfWeLTpZm0lhuv7_s-8cvKv_8sxJUHD0",
})(React.memo(MilestoneMapComponent));
